import React, { useEffect, useMemo, useState } from 'react';
import KapalService from '../../services/kapal/KapalService';

const JenisDokumenKapal = ({id}) => {
    let kapalService = useMemo(() => new KapalService(), [])
    const [jenisDokumen, setJenisDokumen] = useState('')

    useEffect(() => {
        const getJenisDokumen = async () => {
            const response = await kapalService.getJenisDokKapalById(id)
            setJenisDokumen(response.data.jenisDokKapal)
        }
        getJenisDokumen()
    }, [kapalService, id])

    return (
        <>
            {jenisDokumen}
        </>
    )
}

export default JenisDokumenKapal